import Header from "../../components/header/Header";
import './Imprint.css';
import Footer from "../../components/footer/Footer";
import React from "react";
import {useTranslation} from "react-i18next";

const Imprint = () => {
    const { t } = useTranslation();

    return (
        <div className="App">
            <div>
                <Header />
                <div className="imprint">
                    <h3 dangerouslySetInnerHTML={{__html: t("imprint.headline")}} />
                    <p>
                        Evi Baumgartner<br />
                        Gut Capellen<br />
                        53913 Swisttal<br />
                        02254 - 84 72 38<br />
                        evi@evelandmedia.de
                    </p>
                    <h3 dangerouslySetInnerHTML={{__html: t("imprint.validFor.headline")}} />
                    <p dangerouslySetInnerHTML={{__html: t("imprint.validFor.text")}} />
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default Imprint